import { atom } from "recoil"

const disableRootElementScrollState = atom({
  key: 'disableRootElementScrollState',
  default: false,
});

export default disableRootElementScrollState;
